/* eslint-disable no-console */
import { Table } from "react-bootstrap";
import { useValidation } from "../validation/validation";
import { UnMapAllButton } from "../Buttons/Buttons";
import { useProjects, hasMultipleTrackGroups, allowMappingFiles, hideTotalDuration } from "../Behaviors/projects";
import { transformTrackGroups, transformTracks } from "../Behaviors/trackView";
import { useStore } from "../State/zustandStore";
import { ProjectType, Resource } from "../api";
import { TrackRow } from "./TrackRow";

interface Props {
    projectId?: string /* The '?' makes projectId optional */
}

export const TrackList = ({ projectId }: Props) => {

    console.log("TrackList projectId", projectId);

    const {
        getTrackValidationErrors,
        getTrackValidationWarnings,
        getTrackValidationInstructions,
        getTrackValidationRestrictions,
    } = useValidation(projectId!);

    const workspaceState = useStore().projects;
    const projId = projectId
        ? projectId
        : workspaceState.selectedProjectId;
    const { project, getMappedResource, getTracks, getTrackGroups } = useProjects(projId!);
    const projectType = project?.projectType;

    console.log("TrackList projectType", projectType);

    if (projectType !== ProjectType.Release && projectType !== ProjectType.Resource) {
        return null;
    }

    const multipleTrackGroups = hasMultipleTrackGroups(project!);
    const showPrompt = allowMappingFiles(project!);
    const hideDuration = hideTotalDuration(project!);
    const normalView = !projectId;
    const trackViews = multipleTrackGroups // AT-3499
        ? transformTrackGroups(getTrackGroups(project!), hideDuration)
        : transformTracks(getTracks(project!));

    console.log(`TrackList has ${trackViews.length} tracks.`);
    console.log(`normalView=${normalView} showPrompt=${showPrompt} hideDuration=${hideDuration}`);
    return (
        <>
            <Table role={"list"}
                aria-labelledby="tracklist-heading"
                className={"product-track-list mb-0  "}
                aria-label="R2 Track List"
                size="sm">
                {
                    trackViews.map(track => {
                        const iAudioResource = getMappedResource(track) as Resource;
                        const hasMappedFile = iAudioResource !== undefined;
                        const trackValidatoinErrors = getTrackValidationErrors(project!.jobId, track);
                        const trackValidationRestrictions = getTrackValidationRestrictions(project!.jobId, track);
                        const trackValidationWarnings = getTrackValidationWarnings(project!.jobId, track);
                        const trackValidationInstructions = getTrackValidationInstructions(project!.jobId, track, (iAudioResource !== undefined));
                        const hasTrackValidationErrors = (trackValidatoinErrors?.length > 0);
                        const hasTrackValidationRestrictions = (trackValidationRestrictions?.length > 0);
                        const hasTrackValidationWarnings = (trackValidationWarnings?.length > 0);
                        const hasMessages = hasTrackValidationErrors || hasTrackValidationRestrictions || hasTrackValidationWarnings;

                        console.log(`hasMappedFile=${hasMappedFile} hasMessages=${hasMessages}`);
                        return <TrackRow
                            style={null}
                            track={track}
                            projectId={projectId}
                            projectType={project?.projectType}
                            normalView={normalView}
                            multipleTrackGroups={multipleTrackGroups}
                            showPrompt={showPrompt}
                            iAudioResource={iAudioResource}
                            trackMsgs={trackValidatoinErrors.concat(trackValidationRestrictions).concat(trackValidationWarnings)}
                            hasValidationErrors={hasTrackValidationErrors}
                            hasValidationRestrictions={hasTrackValidationRestrictions}
                            hasValidationWarnings={hasTrackValidationWarnings}
                            validationInstructions={trackValidationInstructions}
                            registerChild={null}
                        />;
                    })
                }
                {normalView ? /*hide if called from discrepancy report page*/
                    <>
                        <tbody className={"filler-row"}>
                            <tr className={"filler-row"} />
                        </tbody>
                        <tfoot>
                            <tr>
                                <td style={{ width: "100%" }} colSpan={9} />
                                <td className={"iconic"}><UnMapAllButton /></td>
                            </tr>
                        </tfoot>
                    </>
                    : null
                }
            </Table>
        </>
    );
};
